import React from 'react';
import { useIntl } from 'react-intl';
import { ApiFilterOperation, Evidence } from '@eas/common-web';
import { DecisionState } from '@enums';
import { useDecisions } from '../decision/decisions';

export function ToMakeAccessibleDecisions() {
  const intl = useIntl();

  const defaultPreFilters = [
    {
      field: 'state.id',
      operation: ApiFilterOperation.EQ,
      value: DecisionState.TO_MAKE_ACCESSIBLE,
    },
  ];

  const { evidenceBag } = useDecisions({
    evidenceProps: {
      tableProps: {
        defaultPreFilters,
        tableName: intl.formatMessage({
          id: 'ES__TO_MAKE_ACCESSIBLE_DECISIONS__TABLE__TITLE',
          defaultMessage: 'Rozhodnutí - k zpřístupnění',
        }),
      },
    },
  });

  return <Evidence {...evidenceBag} />;
}
